import React from "react";
import { OverviewSubheader } from "../../layouts";
import {
  ResponsiveTable,
  ErrorBoundary,
  Loaders,
} from "../..";
import { useCompanyAccountsInvitesList } from "../../../queries/company";
import usePagination from "../../../hooks/usePagination";
import { formatDate } from "../../../utils/datetime";

function AccountsInvitesList({companyId}) {
  const pageConfig = usePagination();
  const invitesList = useCompanyAccountsInvitesList({company_id: companyId, ...pageConfig.current});

  const tableData = React.useMemo(
    () => {
      if (invitesList.isSuccess)
        return invitesList.data.data
      else
        return []
    },
    [invitesList]
  );


  const columns = React.useMemo(
    () => {
      if (invitesList.isSuccess){
        return [
          {
            Header: 'Email',
            accessor: 'email'
          },
          {
            Header: 'Role',
            accessor: 'role_name'
          },
          {
            Header: 'Sent at',
            accessor: 'sent_at',
            Cell: ({value}) => formatDate(value, 'MMM dd, yyyy, hh:mm a') 
          },
          {
            Header: 'Expired',
            accessor: 'expired',
            Cell: ({value}) => value ? "Yes" : "No"
          },
        ]
      }
      else{
        return []
      }
    },
    [invitesList]
  );

  if (invitesList.isLoading)
    return <Loaders.ListPageLoader />

  return (
    <ErrorBoundary>
      <OverviewSubheader left='Pending Account Invites' tooltipDesc="The invites that have not been accepted. Please reach out to Spaced Ventures team if an invite has expired before the team member has accepted." />
      <ResponsiveTable title="Invites" columns={columns} data={tableData}/>
    </ErrorBoundary>
  )
}

export default AccountsInvitesList;